module.exports = __webpack_public_path__ + "assets/img/kryt-na-limec-89.0e11f303.png";